import React from 'react'

interface ArrowProps {
    color?: string
    className?: string
}

const DownArrowBlack: React.FC<ArrowProps> = ({ className }) => (
    <svg
        width="9"
        height="6"
        viewBox="0 0 9 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <g id="chevron">
            <path
                id="Vector (Stroke)"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.146447 0.203637C0.341709 0.00837441 0.658291 0.00837443 0.853553 0.203637L4.5 3.85008L8.14645 0.203637C8.34171 0.00837486 8.65829 0.00837487 8.85355 0.203637C9.04882 0.398899 9.04882 0.715482 8.85355 0.910744L4.5 5.2643L0.146447 0.910743C-0.0488156 0.715481 -0.0488156 0.398899 0.146447 0.203637Z"
                fill="currentColor"
            />
        </g>
    </svg>
)

export default DownArrowBlack
